"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppMemoryStorage = void 0;
var AppMemoryStorage = /** @class */ (function () {
    function AppMemoryStorage() {
        this.length = 0;
        this.allKeys = [];
    }
    AppMemoryStorage.prototype.clear = function () {
        var _this = this;
        this.allKeys.forEach(function (key) { return delete _this[key]; });
        this.allKeys = [];
        this.length = 0;
    };
    AppMemoryStorage.prototype.getItem = function (key) {
        return this[key] || null;
    };
    AppMemoryStorage.prototype.key = function (index) {
        return this.allKeys[index];
    };
    AppMemoryStorage.prototype.removeItem = function (key) {
        delete this[key];
        var index = this.allKeys.indexOf(key);
        if (index > -1) {
            this.allKeys.splice(index, 1);
        }
        this.length = this.allKeys.length;
    };
    AppMemoryStorage.prototype.setItem = function (key, value) {
        this[key] = value;
        this.length = this.allKeys.length;
    };
    return AppMemoryStorage;
}());
exports.AppMemoryStorage = AppMemoryStorage;
//# sourceMappingURL=AppMemoryStorage.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/core/dist/services/impl/AppMemoryStorage.js
// module id = 1901
// module chunks = 0